import { useEffect, useState } from "react";

const UseFood = (isReload) => {
  const [food, setFood] = useState([]);
  useEffect(() => {
    fetch("  https://stormy-dawn-44996.herokuapp.com/food")
      .then((res) => res.json())
      .then((data) => setFood(data));
  }, [isReload]);

  return [food, setFood];
};

export default UseFood;
